export enum ControllerTouchpadAxis {
  X = 'X',
  Y = 'Y'
}